module.exports = __webpack_public_path__ + "img/chufangbanner1.632e5243.png";